import template from './../../templates/components/dev.dot'

export let build = () => {

}